// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"184":"f94e0332","212":"f8bb168a","261":"73c79966","275":"d79d2c75","795":"018112b5","804":"f94e0332"}[chunkId] + ".css";
};